import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/omega-ratio-calculator',
  component: () => import('../../routes/OmegaRatioCalculator.svelte'),
  card: {
    id: 'omega-ratio-calculator',
    title: 'Omega Ratio',
    description:
      'Measure the complete risk-return profile of an investment — captures both upside and downside beyond a threshold.',
    icon: 'balance',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/omega-ratio-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Omega Ratio Calculator – Complete Risk-Return Measure',
    description:
      'Free Omega Ratio calculator measures investment performance using the complete distribution of returns. Omega captures both upside and downside beyond a threshold — more comprehensive than Sharpe or Sortino ratios.',
  },
};

export default meta;
